//@flow
import React from "react"
import { connect } from "react-redux"
import { setModal } from "./redux"
import styled from "styled-components"
import { Switch } from "react-router-dom"

import type {
  Location,
  RouterHistory,
  Route as RouteType
} from "react-router-dom"

import type { SetModal } from "./redux"

type Props = {
  location: Location,
  setModal: SetModal,
  history: RouterHistory,
  children: React$Element<any>,
  ModalRoutes: Array<RouteType>,
  Container: ?Class<React.Component<any, any>>
}

const BaseContainer = styled.div`
  display: block;
  margin: 0;
  position: relative;
  height: 100vh;
  width: 100vw;
`

class ModalSwitch extends React.Component<Props> {
  previousLocation = this.props.location

  componentWillUpdate(nextProps: Props) {
    const { location } = this.props
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== "POP" &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { location: { state }, setModal } = this.props
    const prevModal = prevProps.location.state
      ? prevProps.location.state.modal
      : null
    const currentModal = state ? state.modal : null
    if (currentModal !== prevModal) {
      setModal(currentModal || false)
    }
  }

  render() {
    const { location, children, ModalRoutes, Container } = this.props
    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location
    )
    const ContainerComponent = Container ? Container : BaseContainer
    return (
      <ContainerComponent>
        <Switch location={isModal ? this.previousLocation : location}>
          {children}
        </Switch>
        {isModal ? <Switch>{ModalRoutes}</Switch> : null}
      </ContainerComponent>
    )
  }
}

export default connect(null, { setModal })(ModalSwitch)



// WEBPACK FOOTER //
// ./src/Modal/ModalSwitch.js